
import React, { useEffect, useState } from 'react';
import api from '../utils/api';

const CarServiceHistory = () => {
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let mounted = true;
		setLoading(true);
		api.get('/service-bookings/my')
			.then(res => {
				if (mounted) {
					setItems(res.data.items || []);
					setError(null);
				}
			})
			.catch(err => {
				if (mounted) {
					setError(err.response?.data?.message || 'Алдаа гарлаа');
				}
			})
			.finally(() => {
				if (mounted) setLoading(false);
			});
		return () => { mounted = false; };
	}, []);

	if (loading) return <div style={{ padding: 32 }}>Уншиж байна...</div>;
	if (error) return <div style={{ padding: 32, color: 'red' }}>{error}</div>;

	return (
		<div style={{ padding: 32 }}>
			<h2>Үйлчилгээний түүх</h2>
			{items.length === 0 ? (
				<div>Үйлчилгээний захиалга олдсонгүй.</div>
			) : (
				<ul style={{ listStyle: 'none', padding: 0 }}>
					{items.map((item, idx) => (
						<li key={item.id || idx} style={{ marginBottom: 16, border: '1px solid #eee', borderRadius: 8, padding: 16, background: '#fafbfc' }}>
							<div><strong>{item.carModel}</strong> — {item.plateNumber}</div>
							<div>Үйлчилгээ: {item.serviceType}</div>
							<div>Огноо: {item.preferredDate ? new Date(item.preferredDate).toLocaleDateString() : '-'}</div>
							<div>Төлөв: {item.status}</div>
							{item.note && <div>Тайлбар: {item.note}</div>}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default CarServiceHistory;
